<template>
  <span>
    <el-button icon="el-icon-document" class="pdf-button" type="text" @click="open(trace.id)">LOG</el-button>
    <el-dialog :visible.sync="visible" :lock-scroll="true" @open="hideScroll" @close="showScroll">
      <div v-if="error">{{error}}</div>
      <div v-if="loading">Загрузка логов...</div>
      <div v-for="item in log" :key="item.request_id" class="log_wrapper">
        <div class="log_row">
          <div class="log_header">
            <div>{{item.method}}</div>
            <div>{{item.request_id}}</div>
          </div>
          <div class="log_body">
            <div class="log_req">
              <div class="log_block_header">Request header: <button v-clipboard="item.request.header">Копировать</button></div>
              <pre class="item_header">{{item.request.header}}</pre>
              <div class="log_block_header">Request body: <button v-clipboard="item.request.body">Копировать</button></div>
              <pre class="item_body">{{item.request.body}}</pre>
            </div>
            <div class="log_res">
              <div class="log_block_header">Response header: <button v-clipboard="item.response.header">Копировать</button></div>
              <pre class="item_header">{{item.response.header}}</pre>
              <div class="log_block_header">Response body: <button v-clipboard="item.response.body">Копировать</button></div>
              <pre class="item_body">{{item.response.body}}</pre>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </span>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import { apiUrl } from "@/api/apiUrl";
import Clipboard from 'v-clipboard'

Vue.use(Clipboard)

export default {
  name: "LogView",
  props: {
    trace: {
      type: Object,
      required: true
    }
  },
  methods: {
    hideScroll() {
      document.documentElement.style.overflow = "hidden";
    },
    showScroll() {
      document.documentElement.style.overflow = "auto";
    },
    open(trace_id)  {
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      this.error = ''
      this.loading = true
      axios
          .post(apiUrl + "transaction/log", {trace_id}, config)
          .then(({ data }) => {
              this.log = data.items
          }).catch(err => {
            switch (err.response.status) {
              case 404:
                this.error = 'Логи не найдены'
                break;
              case 401:
              case 403:
                this.error = 'Нет прав на просмотр данных логов'
                break;
              default:
                this.error = 'Упс! что-то пошло не так'
            }
        }).finally(() => {
          this.loading = false
        })
      this.visible = true
    },
  },
  data() {
    return {
      visible: false,
      log: [],
      loading: false,
      loaded: false,
      error: ''
    };
  },

}
</script>

<style scoped>
  .log_wrapper{
    display: flex;
    width: 100%;
  }
  .log_row{
    display: flex;
    flex-direction: column;
    text-align: left;

    width: 100%;
    padding: 6px;
    background-color: beige;
    margin-bottom: 55px;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
  }
  .log_header{
    padding: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .log_body {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: row;
    align-items: center;
  }
  .log_req, .log_res {
    display: flex;
    flex-direction: column;
    width: 50%;
    padding: 5px;
  }
  .log_req:before,  .log_res:before {
    display: flex;
    content: '';
    padding: 10px;
    background-color: #4b79a4;
    color: #ceced0;
    font-size: 16px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .log_req:before {
    content: 'Запрос к банку';
  }
  .log_res:before {
    content: 'Ответ от банка';
  }
  .log_block_header {
    background-color: #82848a;
    padding: 4px;
    text-align: left;
    display: flex;
    justify-content: space-between;
  }
  .item_header, .item_body {
    overflow: auto;
    width: 100%;
    height: 250px;
    background-color: #ceced0;
    text-align: left;
    margin: 0 !important;
  }

</style>